<form id="contact-information" [formGroup]="regForm" (ngSubmit)="step4Submitted(regForm)" novalidate>




  <div class="form-row">
    <label style="font-weight: bold; font-size: x-large;">{{'Step4-Education.TranslationSection.text1' | translate}}</label>
  
  </div><br><br>
  





    <div class="form-row" >

      <div class="form-group col-lg-5 col-md-5  col-sm-5" >
        <label style="font-weight: bold;">{{'Step4-Education.TranslationSection.text2' | translate}}</label>
        <input type="text" class="form-control" for="HSName"  formControlName="HSName" id="HSName" placeholder="" [ngClass]="{'form-submitted': isSubmitted}">
      </div>


      <div class="form-group col-lg-5 col-md-5 col-sm-5" >
        <label>{{'Step4-Education.TranslationSection.text3' | translate}}</label>
        <input type="text" class="form-control" for="HSLocation"  formControlName="HSLocation" id="HSLocation" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
      </div>

    
    </div>


    <div class="form-row" >

      <div class="form-group col-lg-7 col-md-7 col-sm-7">

        <label>{{'Step4-Education.TranslationSection.text4' | translate}}</label>&nbsp;<br>
      
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="pa" formControlName="HSLast_Year_Completed" value="9" >
          <label class="form-check-label" for="yes">9</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="pa" formControlName="HSLast_Year_Completed" value="10" >
          <label class="form-check-label" for="yes">10</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="pa" formControlName="HSLast_Year_Completed" value="11" >
          <label class="form-check-label" for="yes">11</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="pa" formControlName="HSLast_Year_Completed" value="12" >
          <label class="form-check-label" for="yes">12</label>
        </div>

        <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('HSLast_Year_Completed').invalid">
          ***required field***
      </div>
      </div>


      <div class="form-group col-lg-5 col-md-5 col-sm-5">

        <label>{{'Step4-Education.TranslationSection.text5' | translate}}</label>&nbsp;
      
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio"  id="pa1" formControlName="HSGraduate" value="Yes" (click)="toggleGEDClick('Yes')">
            <label class="form-check-label" for="yes">{{'Step4-Education.TranslationSection.text6' | translate}}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio"  id="cons1" formControlName="HSGraduate" value="No" (click)="toggleGEDClick('No')">
            <label class="form-check-label" for="yes">{{'Step4-Education.TranslationSection.text7' | translate}}</label>
          </div>

          <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('HSGraduate').invalid">
            ***required field***
        </div>
      </div>


  
    </div>






    <div class="form-row" >

      <div class="form-group col-lg-7 col-md-7  col-sm-7">
      </div>


      <div class="form-group col-lg-5 col-md-5 col-sm-5">

        <label>{{'Step4-Education.TranslationSection.text8' | translate}}</label>&nbsp;
      
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio"  id="pa2" formControlName="GED" value="Yes" >
            <label class="form-check-label" for="yes">{{'Step4-Education.TranslationSection.text9' | translate}}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio"  id="cons2" formControlName="GED" value="No" >
            <label class="form-check-label" for="yes">{{'Step4-Education.TranslationSection.text10' | translate}}</label>
          </div>
          <div style="color: red;" *ngIf="isSubmitted && this.regForm.get('GED').invalid">
            ***required field***
        </div>
      </div>
  
    </div>


    <div class="form-row" style="height:50px;"></div>


    <div class="form-row" >

      <div class="form-group col-lg-6 col-md-6  col-sm-6" >
        <label  style="font-weight: bold;">{{'Step4-Education.TranslationSection.text11' | translate}}</label>
        <input type="text" class="form-control" for="ColName"  formControlName="ColName" id="ColName" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
      </div>


      <div class="form-group col-lg-6 col-md-6  col-sm-6" >
        <label>{{'Step4-Education.TranslationSection.text12' | translate}}</label>
        <input type="text" class="form-control" for="ColLocation"  formControlName="ColLocation" id="ColLocation" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
      </div>

  
    </div>



    <div class="form-row" >

      <div class="form-group col-lg-6 col-md-6  col-sm-6">

        <label>{{'Step4-Education.TranslationSection.text13' | translate}}</label>&nbsp;<br>
      
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="collast" formControlName="ColLast_Year_Completed" value="01" >
          <label class="form-check-label" for="yes">1</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="collast" formControlName="ColLast_Year_Completed" value="02" >
          <label class="form-check-label" for="yes">2</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="collast" formControlName="ColLast_Year_Completed" value="03" >
          <label class="form-check-label" for="yes">3</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="collast" formControlName="ColLast_Year_Completed" value="04" >
          <label class="form-check-label" for="yes">4</label>
        </div>
      </div>


      <div class="form-group col-lg-5 col-md-5 col-sm-5">

        <label>{{'Step4-Education.TranslationSection.text14' | translate}}</label>&nbsp;
      
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio"  id="pa" formControlName="ColGraduate" value="Yes" >
            <label class="form-check-label" for="yes">{{'Step4-Education.TranslationSection.text15' | translate}}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio"  id="cons" formControlName="ColGraduate" value="No" >
            <label class="form-check-label" for="yes">{{'Step4-Education.TranslationSection.text16' | translate}}</label>
          </div>
      </div>

    </div>





    <div class="form-row" >
    <div class="form-group col-lg-6 col-md-6  col-sm-6">

      <label>{{'Step4-Education.TranslationSection.text17' | translate}}</label>&nbsp;

      <input type="text" class="form-control" for="ColMajor_Course"  formControlName="ColMajor_Course" id="ColMajor_Course" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
        
    </div>


    <div class="form-group col-lg-5 col-md-5  col-sm-5">

      <label>{{'Step4-Education.TranslationSection.text18' | translate}}</label>&nbsp;

      <input type="text" class="form-control" for="ColDiploma_Degree"  formControlName="ColDiploma_Degree" id="ColDiploma_Degree" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >

    </div>
  </div>


    <div class="form-row" style="height:50px;"></div>

    <div class="form-row" >

      <div class="form-group col-lg-6 col-md-6  col-sm-6" >
        <label  style="font-weight: bold;">{{'Step4-Education.TranslationSection.text19' | translate}}</label>
        <input type="text" class="form-control" for="primaryPhone"  formControlName="OTHName" id="primaryPhone" placeholder="" [ngClass]="{'form-submitted': isSubmitted}">
      </div>


      <div class="form-group col-lg-5 col-md-5  col-sm-5" >
        <label>{{'Step4-Education.TranslationSection.text20' | translate}}</label>
        <input type="text" class="form-control" for="secondaryPhone"  formControlName="OTHLocation" id="secondaryPhone" placeholder="" [ngClass]="{'form-submitted': isSubmitted}">
      </div>

    
    </div>





    <div class="form-row">

      <div class="form-group col-lg-6 col-md-6 col-sm-6">

        <label>{{'Step4-Education.TranslationSection.text21' | translate}}</label>&nbsp;<br>
      
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="pa" formControlName="OTHLast_Year_Completed" value="01" >
          <label class="form-check-label" for="yes">1</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="pa" formControlName="OTHLast_Year_Completed" value="02" >
          <label class="form-check-label" for="yes">2</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="pa" formControlName="OTHLast_Year_Completed" value="03" >
          <label class="form-check-label" for="yes">3</label>
        </div>
        <div class="form-check form-check-inline">
          <input class="form-check-input" type="radio"  id="pa" formControlName="OTHLast_Year_Completed" value="04" >
          <label class="form-check-label" for="yes">4</label>
        </div>
      </div>


      <div class="form-group col-lg-5 col-md-5 col-sm-5">

        <label>{{'Step4-Education.TranslationSection.text22' | translate}}</label>&nbsp;
      
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio"  id="pa" formControlName="OTHGraduate" value="Yes" >
            <label class="form-check-label" for="yes">{{'Step4-Education.TranslationSection.text23' | translate}}</label>
          </div>
          <div class="form-check form-check-inline">
            <input class="form-check-input" type="radio"  id="cons" formControlName="OTHGraduate" value="No" >
            <label class="form-check-label" for="yes">{{'Step4-Education.TranslationSection.text24' | translate}}</label>
          </div>
      </div>

    </div>



    <div class="form-row" >
    <div class="form-group col-lg-6 col-md-6  col-sm-6">

      <label>{{'Step4-Education.TranslationSection.text25' | translate}}</label>&nbsp;

      <input type="text" class="form-control" for="OTHMajor_Course"  formControlName="OTHMajor_Course" id="OTHMajor_Course" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
       
    </div>


    <div class="form-group col-lg-5 col-md-5  col-sm-5">

      <label>{{'Step4-Education.TranslationSection.text26' | translate}}</label>&nbsp;
      <input type="text" class="form-control" for="OTHDiploma_Degree"  formControlName="OTHDiploma_Degree" id="OTHDiploma_Degree" placeholder="" [ngClass]="{'form-submitted': isSubmitted}" >
    
    </div>
  </div>



<br>



<button type="button" (click) = "decreasePage()" class="btn btn-create"  matStepperPrevious><i className="ace-icon fa fa-arrow-left"></i>{{'Step4-Education.TranslationSection.text27' | translate}}</button>
&nbsp;
<button type="submit"  class="btn btn-primary" >{{'Step4-Education.TranslationSection.text28' | translate}} &nbsp;
<i className="ace-icon fa fa-arrow-right icon-on-right"></i></button>   


<div class="spinner-border text-success" role="status" style="position: absolute; bottom:10;" *ngIf="isfetching === true"></div>
&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<i className="fa fa-spinner fa-spin  fa-2x" style="color:blue" *ngIf="isfetching === true"> {{'Step4-Education.TranslationSection.text29' | translate}}</i>





</form>